// extracted by mini-css-extract-plugin
export var container = "_33-0";
export var error = "_33-9";
export var label = "_33-5";
export var light = "_33-6";
export var md = "_33-3";
export var sm = "_33-2";
export var thin = "_33-8";
export var thinBold = "_33-7";
export var vertical = "_33-4";
export var xs = "_33-1";